import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProductReveal() {
  return <section className="px-6 py-5 max-w-5xl mx-auto" data-id="element-442">
      <FadeIn data-id="element-443">
        <div className="text-center mb-10" data-id="element-444">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-[#4A5D3A] mb-6" data-id="element-445">
            RESCATE HERBÁCEO S.O.S.
          </h1>
          <p className="text-xl md:text-2xl font-serif italic text-[#9B4F2B] max-w-3xl mx-auto leading-relaxed" data-id="element-446">
            El protocolo botánico de 15 minutos para cuando tu mente no se apaga
            por la noche.
          </p>
        </div>

        <div className="relative w-full max-w-3xl mx-auto mb-10 rounded-2xl overflow-hidden shadow-2xl" data-id="element-447">
          <img src="https://cdn.magicpatterns.com/uploads/hqDfq9WhQEb4HF8VDKWm61/MOCKUP.png" alt="Rescate Herbáceo S.O.S. Digital Product Bundle" className="w-full h-auto object-cover" data-id="element-448" />
        </div>

        <div className="max-w-3xl mx-auto space-y-4 text-lg md:text-xl text-center text-[#2D2A26]" data-id="element-449">
          <p className="text-[#4A5D3A] font-[700]" data-id="element-450">
            Esto no es otro ebook de bienestar.
          </p>
          <p className="text-[#9B4F2B] font-medium" data-id="element-451">❌ No es un teoría.</p>
          <p className="text-[#9B4F2B] font-medium" data-id="element-452">
            ❌ No es “piensa positivo”.
          </p>
          <p className="text-[#9B4F2B] font-medium" data-id="element-453">
            ❌ No es un té relajante genérico.
          </p>
          <p className="text-[#4A5D3A] font-[700]" data-id="element-454">
            ✔ Es un protocolo botánico práctico que puedes aplicar esta misma
            noche.
          </p>

          <div className="bg-[#4A5D3A]/5 p-6 md:p-10 rounded-3xl mt-8 border border-[#4A5D3A]/20" data-id="element-455">
            <p className="mb-6 leading-relaxed" data-id="element-456">
              {' '}
              <strong className="text-[#4A5D3A]" data-id="element-457">
                Es una guía práctica de acción inmediata
              </strong>{' '}
              Un protocolo construido alrededor de 3 plantas específicas,
              preparadas en la dosis correcta para enviarle a tu sistema
              nervioso la señal que necesita para salir del modo alerta.
            </p>
            <p className="mb-6 leading-relaxed" data-id="element-458">
              {' '}
              <strong className="text-[#4A5D3A]" data-id="element-459">
                En palabras simples:
              </strong>{' '}
            </p>
            <h2 className="text-3xl md:text-4xl font-serif italic text-[#4A5D3A] font-bold" data-id="element-460">
              "Estamos a salvo. Ya puedes descansar."
            </h2>
          </div>
        </div>
      </FadeIn>
    </section>;
}